export enum InstallmentFrequency {
	Weekly = 1,
	Every2Weeks = 2,
	Every28Days = 3,
	Monthly = 4,
	FifteenthOfEachMonth = 5,
	EndOfMonth = 6,
	Every2Months = 7
}
